__webpack_require__.p = "https://assets-01.periodica.press/50d0331-21033995180/";